import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=32de00fe&scoped=true&"
import script from "./bargain.vue?vue&type=script&lang=js&"
export * from "./bargain.vue?vue&type=script&lang=js&"
import style0 from "./bargain.vue?vue&type=style&index=0&id=32de00fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de00fe",
  null
  
)

export default component.exports